import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  question: '¿Necesito un abogado para hacer esto válido?',
  answer: 'No. El Protocolo Sombrilla está diseñado para que puedas completar los documentos tú mismo. Sin embargo, siempre recomendamos notarizar los documentos (lo cual cuesta unos pocos dólares en cualquier banco o servicio de envíos) para darles máxima validez legal.'
}, {
  question: '¿Funciona si no tengo papeles?',
  answer: 'Absolutamente. De hecho, está diseñado ESPECÍFICAMENTE para personas sin estatus legal. Tus derechos como padre y dueño de bienes existen independientemente de tu estatus migratorio.'
}, {
  question: '¿Es un producto físico o digital?',
  answer: 'Es 100% digital. Recibirás acceso inmediato a la plataforma donde podrás descargar los PDF, ver los videos y acceder a las plantillas. Puedes hacerlo desde tu celular o computadora.'
}, {
  question: '¿Qué pasa si vivo en un estado diferente?',
  answer: 'Las leyes de custodia y poderes notariales son similares en la mayoría de los estados, pero incluimos variaciones y recomendaciones para cubrirte a nivel nacional.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-slate-50" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <div className="max-w-3xl mx-auto" data-id="element-3">
          <h2 className="text-3xl font-bold text-slate-900 text-center mb-12" data-id="element-4">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-5">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg shadow-sm border border-slate-200 overflow-hidden" data-id="element-6">
                <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-7">
                  <span className="font-bold text-slate-900 text-lg" data-id="element-8">
                    {faq.question}
                  </span>
                  {openIndex === index ? <ChevronUp className="w-5 h-5 text-slate-500" data-id="element-9" /> : <ChevronDown className="w-5 h-5 text-slate-500" data-id="element-10" />}
                </button>
                {openIndex === index && <div className="px-6 pb-6 text-slate-600" data-id="element-11">{faq.answer}</div>}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}